(function () {
  var root = document.querySelector('[data-vk-welcome-offer]');
  if (!root || root.dataset.vkReady === 'true') return;

  root.dataset.vkReady = 'true';

  var dialog = root.querySelector('[data-vk-offer-dialog]');
  var closeButtons = root.querySelectorAll('[data-vk-offer-close]');
  var copyButton = root.querySelector('[data-vk-copy-offer]');
  var storageKey = 'vk-welcome-offer:' + (root.dataset.offerKey || 'launch-1');
  var lastFocused = null;

  function wasDismissed() {
    try {
      return window.localStorage.getItem(storageKey) === 'dismissed';
    } catch (error) {
      return false;
    }
  }

  function rememberDismissal() {
    try {
      window.localStorage.setItem(storageKey, 'dismissed');
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; closing still works.
    }
  }

  function openOffer() {
    if (wasDismissed()) return;
    lastFocused = document.activeElement;
    root.hidden = false;
    document.body.classList.add('vk-offer-open');
    window.requestAnimationFrame(function () {
      dialog.focus();
    });
  }

  function closeOffer() {
    rememberDismissal();
    root.hidden = true;
    document.body.classList.remove('vk-offer-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeOffer);
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;
    if (event.key === 'Escape') closeOffer();
    if (event.key !== 'Tab') return;

    var focusable = Array.from(
      dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var code = root.querySelector('[data-vk-offer-code]');
      if (!code) return;

      navigator.clipboard.writeText(code.textContent.trim()).then(function () {
        copyButton.textContent = 'Copied';
        window.setTimeout(function () {
          copyButton.textContent = 'Copy code';
        }, 1800);
      });
    });
  }

  if (!wasDismissed()) {
    window.setTimeout(openOffer, Number(root.dataset.delay || 2000));
  }
})();
